import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VStack } from "native-base";
import { useCallback } from "react";
import PreOpSurveyFormRow from "../../../molecules/PreOpSurveyFormRow";
import FormControl from "../../../form/FormControl";
import PreOpWrapper from "./PreOpWrapper";
const Survey1 = ({ onPreviousPress, onNextPress }) => {
    const validate = useCallback(({ answers, subAnswers, }) => {
        var _a, _b, _c, _d, _e, _f;
        return (!(answers === null || answers === void 0 ? void 0 : answers.drugAllergy) ||
            ((_b = (_a = subAnswers === null || subAnswers === void 0 ? void 0 : subAnswers.drugAllergy) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : "").length > 3) &&
            (!(answers === null || answers === void 0 ? void 0 : answers.takingMedicine) ||
                ((_d = (_c = subAnswers === null || subAnswers === void 0 ? void 0 : subAnswers.takingMedicine) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : "").length > 3) &&
            (!(answers === null || answers === void 0 ? void 0 : answers.otherDisease) ||
                ((_f = (_e = subAnswers === null || subAnswers === void 0 ? void 0 : subAnswers.otherDisease) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : "").length > 3);
    }, []);
    return (_jsx(PreOpWrapper, Object.assign({ onPreviousPress: onPreviousPress, onNextPress: onNextPress, validate: validate, width: "full", justifyContent: "flex-start", alignItems: "flex-start" }, { children: _jsxs(VStack, { children: [_jsx(PreOpSurveyFormRow, { name: "drugAllergy", optionalAnswerInput: _jsx(FormControl, { name: "subAnswers.drugAllergy.0", size: "md", placeholder: "Adja meg milyen gy\u00F3gyszerekre \u00E9rz\u00E9keny.", isRequired: true }) }), _jsx(PreOpSurveyFormRow, { name: "takingMedicine", optionalAnswerInput: _jsx(FormControl, { name: "subAnswers.takingMedicine.0", size: "md", placeholder: "Adja meg milyen gy\u00F3gyszert szed.", isRequired: true }) }), _jsx(PreOpSurveyFormRow, { name: "diseases", hasOptionalAnswer: false }), _jsx(PreOpSurveyFormRow, { name: "heartDisease", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "highBloodPressure", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "arrhythmia", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "vascularIssues", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "asthma", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "breathlessness", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "stroke", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "epilepsy", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "diabetes", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "thyroid", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "bleedingDisorder", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "hepatitis", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "acidReflux", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "muscleWeakness", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "sleepDisorder", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "eyeDisease", pl: {
                        base: 8,
                        md: 10,
                    } }), _jsx(PreOpSurveyFormRow, { name: "otherDisease", pl: {
                        base: 8,
                        md: 10,
                    }, hasDivider: false, optionalAnswerInput: _jsx(FormControl, { name: "subAnswers.otherDisease.0", size: "md", placeholder: "K\u00E9rj\u00FCk r\u00E9szletezze", isRequired: true }) })] }) })));
};
export default Survey1;
